export default __webpack_public_path__ + "static/media/manutencaoP.293493df.png";